<template>
  <div class="customer_list">
    <div class="sales_header">
      <div class="chouse_wrap">
        <ul class="task_list_list">
          <li class="task_list_item bianhao">
            <el-input placeholder="客户编号、姓名、电话" v-model="searchInfo.clientId" @input="handleCurrentChange(1)" clearable></el-input>
          </li>
          <li class="task_list_item zhuangtai">
            <div class="txt" style="min-width: 60px;">客源类型：</div>
            <el-select v-model="searchInfo.transactionType" placeholder="不限" @change="handleCurrentChange(1)" @visible-change="getCustomerType" clearable>
              <el-option v-for="(item,index) in customerTypeList" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
            </el-select>
          </li>
          <!-- <li class="task_list_item mendian" style="position: relative">
            <div class="txt" style="min-width: 36px;">部门：</div>
            <el-input style="min-width: 65px" v-model="searchInfo.partmentName" @focus="departpopshow=!departpopshow" clearable @clear="departpopshow=false,searchInfo.partmentName='',searchInfo.storeId='',handleCurrentChange(1)" placeholder="不限"></el-input>
            <div class="departpop" v-if="departpopshow" style=" position: absolute;top: 30px;z-index: 999;">
              <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                <span class="custom-tree-node" slot-scope="{data}">
                  <div>
                    <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                    <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                    <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                    <span>{{ data.name }}</span>
                  </div>
                </span>
              </el-tree>
            </div>
          </li> -->
          <!-- <li class="task_list_item zhuangtai">
            <div class="txt" style="min-width: 60px;">付款方式：</div>
            <el-select v-model="searchInfo.typeValue" placeholder="不限" @change="handleCurrentChange(1)" @visible-change="GetPayway" clearable>
              <el-option v-for="(item,index) in typeData" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
            </el-select>

          </li> -->
          <li class="task_list_item zhuangtai">
            <div class="txt" style="width: 36px;">来源：</div>
            <el-select v-model="searchInfo.sourceValue" placeholder="不限" @visible-change="getsource" @change="handleCurrentChange(1)" clearable>
              <el-option v-for="(item,index) in source" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
            </el-select>

          </li>
          <!-- <li class="task_list_item zhuangtai">
            <div class="txt" style="min-width: 36px;">员工：</div>

            <el-autocomplete class="select" popper-class="my-autocomplete" v-model="searchInfo.employeeName" :fetch-suggestions="querySearchAsync" placeholder="请选择" @select="handleSelect" clearable>
              <template slot-scope="{ item }">
                <div class="name" @select="handleSelect">{{ item.name }}</div>
              </template>
            </el-autocomplete>
          </li> -->
          <li class="task_list_item zhuangtai">
            <div class="txt" style="min-width: 60px;">客户等级：</div>
            <el-select v-model="searchInfo.levelValue" placeholder="不限" @visible-change="getcustomerLevel" @change="handleCurrentChange(1)" clearable>
              <el-option v-for="(item,index) in customerLevel" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
            </el-select>
          </li>
          <li class="task_list_item zhuangtai">
            <div class="txt" style="min-width: 60px;">录入时间：</div>
            <div class="inp_box" style="width: 240px">
              <el-date-picker @change="handleCurrentChange(1)" value-format="yyyy-MM-dd" v-model="searchInfo.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" clearable>
              </el-date-picker>
            </div>
          </li>
          <li class="task_list_item zhuangtai">
            <div class="txt" style="min-width: 36px;">状态：</div>
            <el-select v-model="searchInfo.status" placeholder="不限" @change="handleCurrentChange(1)" clearable @visible-change="getstatus">
              <el-option v-for="(item,index) in customerStatus" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
            </el-select>
          </li>
        </ul>
      </div>
      <!-- <div class="sales_header_rigth">

        <el-button type="primary" @click="addHouse" v-if="permisShow('客源新增')">

          添加客源
        </el-button>
      </div> -->
    </div>
    <div class="sales_list_wrap">
      <el-table @sort-change="customerSort" border :data="customerData" style="width: 100%;" :header-cell-style="setHeaderStyle" :row-class-name="tableRowClassName" @row-dblclick="gocustomerDetails" @header-click="Choice" @select="handleSelectionChange" ref="multipleTable" highlight-current-row @row-click="rowColorclick">

        <el-table-column label="客户编号" width="80">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.cusCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名" width="80">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性质" width="60">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.pubAndPriv}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="60">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客源类型" width="80">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.customerType}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户需求" :show-overflow-tooltip="true" width="300">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.customerNeed}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="entrustDate" sortable="custom" label="录入时间">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.entrustDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jobTractTime" sortable="custom" label="跟进时间" width="160px">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.jobTractTime}}</span>
          </template>
        </el-table-column>

        <el-table-column label="客源等级" width="80">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.customerLevel}}</span>
          </template>
        </el-table-column>
        <el-table-column label="带看次数" width="80">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.number}}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.remak}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="foot-out">
      <div class="foot-out-left">
        <!--客源统计-->
        <!-- <div class="tongji cusp" @click="Tostatistics">
          <i class="iconfont icon-icon_tongji"></i>客源统计
        </div> -->
        <!--导出-->
        <!-- <div class="daochu cusp" @click="toDao" v-if="permisShow('客源导出')">
          <i class="iconfont icon-icon_daochu"></i>导出
        </div> -->
        <!--收藏-->
        <!-- <div class="shoucang cusp" @click="getCollect">
          <i class="iconfont icon_shoucang"></i>我的收藏
        </div> -->
      </div>
      <div class="foot-out-right">
        <div class="footer_page">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>

    <!--弹出层-->
    <el-dialog title="请选择要导出的信息（多选）" :visible.sync="dialogVisible" width="400px">

      <div class="checkbox-out">
        <div class="checkbox" v-for="(item,index) in checkData" :key="index" style="margin-top: 10px;color:#999999;font-size: 14px ">
          <input type="checkbox" :id="item.name + ':' +  item.id" :value="item.name + ':' + item.id" v-model="checkList">
          <label :for="item.name + ':' +  item.id">{{item.name}}</label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end">
        <el-button @click="cancel" style="background: #999999;color: #ffffff;outline: none;border: none; margin-right: 15px;">取 消</el-button>
        <download-excel class="export-excel-wrapper" :data="customerData" :fields="list" :name="excelName">
          <el-button v-points type="primary" @click="daochu" style="background:#5E75E6;outline: none;border: none; ">确 定</el-button>
        </download-excel>

      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import {
  findCustomer,
  BuyPayWay,
  RentPayWay,
  customerLevel,
  Collect,
  deleteCollect
} from "../../api/customeManage";
import { storeFind, employeeQuery, departmentFind } from "../../api/manageCenter";
import { dicGet, easypoi } from "../../api/index";
export default {
  // name: "客源管理",
  name: "/robCustomer",
  data() {
    let permisList = JSON.parse(sessionStorage.getItem('permisList'));
    let levelList = JSON.parse(sessionStorage.getItem('levelList'));
    return {
      isRowColor: "",
      permisList,
      levelList,
      defaultProps: {
        children: "child"
      },
      departmentList: [], //部门数据
      departpopshow: false, //显示树状图
      permissionLevel: '',
      total: 0,
      storeData: [], //门店
      typeData: [], //付款方式
      source: [], //来源渠道
      customerTypeList: [],//客源类型
      employeesData: [], //员工
      customerLevel: [], //客户等级
      customerData: [],
      customerData1: [],
      searchInfo: {
        partmentName: '',
        storeId: "",
        typeValue: "",
        sourceValue: "",
        employeeId: "",
        employeeName: "",
        levelValue: "",
        date: "",
        key: "",
        clientId: "",//客户编号
        status: '',//客户状态
        robCustomer: 1,
        transactionType: ""
      },
      currentPage: 1,
      pageNumber: 1,
      pageSize: 20,
      checked: false, //选择
      dialogVisible: false,
      checkList: [],
      // checkData:['客户编号','客户姓名','性质','状态','联系电话',"门店","经纪人","客户需求","委托日期","跟进时间","客源等级","备注"],
      checkData: [
        { name: "客户编号", id: "customerId" },
        { name: "客户姓名", id: "name" },
        { name: "性质", id: "pubAndPriv" },
        { name: "状态", id: "status" },
        { name: "联系电话", id: "phoneNumber" },
        { name: "部门", id: "storeName" },
        { name: "经纪人", id: "employeeName" },
        {
          name: "客户需求",
          // id: [
          //   "areaName",
          //   "tradeAreaName",
          //   "residentialAreaName",
          //   "lowLimitAreaMeasure",
          //   "upLimitAreaMeasure",
          //   "lowLimitDoorModel",
          //   "upLimitDoorModel",
          //   "lowLimitPrice",
          //   "upLimitPrice"
          // ]
          id: 'customerNeed'
        },
        { name: "委托日期", id: "entrustDate" },
        { name: "跟进时间", id: "jobTractTime" },
        { name: "客源等级", id: "customerLevel" },
        { name: "备注", id: "remak" }
      ],
      customerType: "",
      danwei: "",
      priceText: "",
      customerId: "", //客源id
      list: {},
      excelName: "",
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "本季度",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      customerStatus: [],//客源状态
      dateUpDown:null,//录入时间排序
      followDateUpDown:null,//跟进时间排序
    };
  },
  methods: {
    //列表排序
    customerSort(column) {
      this.dateUpDown = null;
      this.followDateUpDown=null;
      console.log(column);
      // dateUpDown:null,//录入时间排序
      //         followDateUpDown:null,//跟进时间排序
      if (column.prop=='entrustDate'&& column.order == "ascending") {
        this.dateUpDown = 'UP';
        this.pageNumber = 1;
        this.currentPage = 1;
        this.findCustomer(this.$store.state.customerType);
      }else if (column.prop == "entrustDate" && column.order == "descending"
      ){
        this.dateUpDown = 'DOWN';
        this.pageNumber = 1;
        this.currentPage = 1;
        this.findCustomer(this.$store.state.customerType);
      }else if (column.prop == "jobTractTime" && column.order == "ascending"
      ){
        this.followDateUpDown = 'UP';
        this.pageNumber = 1;
        this.currentPage = 1;
        this.findCustomer(this.$store.state.customerType);
      }else if (column.prop == "jobTractTime" && column.order == "descending"
      ){
        this.followDateUpDown = 'DOWN';
        this.pageNumber = 1;
        this.currentPage = 1;
        this.findCustomer(this.$store.state.customerType);
      }
    },
    //修改当前行字体颜色
    rowColorclick(row) {
      this.isRowColor = row.customerId;
    },
    // permisShow(data) {
    //   // 权限配置
    //   let result = this.permisList.indexOf(data);
    //   if (result >= 0) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    //查询客源状态
    getstatus(value) {
      if (value === true) {
        var state = "";
        if (this.customerType === "WANT_TO_BUY") {
          state = "buyCustomerStatus";
        } else if (this.customerType === "WANT_TO_RENT") {
          state = "rentCustomerStatus";
        }
        var params = {
          code: state
        };
        this.$post(dicGet, params).then(res => {
          if (res.success === true) {
            this.customerStatus = res.data;
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }
    },
    //查询部门
    getdepartmentFindAll() {
      this.$post(departmentFind).then(res => {
        if (res.success) {
          this.departmentList = res.data;
        }
      });
    },
    //选择部门
    handleNodeClick(node, data) {
      this.pageNumber = 1;
      this.searchInfo.partmentName = node.name;
      this.searchInfo.storeId = node.id;
      this.departpopshow = false;
      this.handleCurrentChange(1)
    },
    inpt() {
      this.list = {};
      let changList = [];
      this.checkList.map((item, index) => {
        item = item.split(':');
        changList.push(item)
      });
      changList.map((item, index) => {
        this.list[item[0]] = item[1];
      });
    },
    //查看收藏
    getCollect() {
      this.$router.push({ path: "/customerCollect" });
    },
    //客源收藏
    setCollect(id, collect, deleteId) {
      this.customerId = id;
      if (!collect) {
        //添加收藏
        let params = {
          customerIds: this.customerId,
          transactionType: this.$store.state.customerType
        };
        this.$post(Collect, params).then(res => {
          if (res.success) {
            this.$message({
              message: "收藏成功",
              type: "success"
            });
            this.findCustomer(this.$store.state.customerType);
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      } else {
        //取消收藏
        let params = {
          customerId: this.customerId,
        };
        this.$post(deleteCollect, params).then(res => {
          if (res.success) {
            this.$message({
              message: "取消收藏",
              type: "success"
            });
            this.findCustomer(this.$store.state.customerType);
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.checkList = [];
    },
    ChangText() {
      if (this.$store.state.customerType === "WANT_TO_BUY") {
        this.priceText = "价格";
        this.danwei = "万";
      } else if (this.$store.state.customerType === "WANT_TO_RENT") {
        this.priceText = "租金";
        this.danwei = "元";
      }
    },
    //表单头部颜色
    setHeaderStyle() {
      return "background-color: #F2F4FF";
    },
    //分页
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.findCustomer(this.$store.state.customerType);
      //  //cosole.log(this.$store.state.customerType)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNumber = 1
      this.currentPage = 1
      this.findCustomer(this.$store.state.customerType);

    },
    //选择显示列表弹框
    Choice(event) {
      if (event.label === "标识") {
        this.dialogVisible = true;
      }
    },
    //查询客源
    findCustomer(obj) {
      this.isRowColor = "";
      this.customerType = obj;
      let menu = JSON.parse(localStorage.getItem("menu"));
      if (menu)
        menu.map(item => {
          if (item.name === "客源管理") {
            item.childMenus.map(child => {
              if (obj === "WANT_TO_BUY" && child.name === "求购") {
                let result = false
                child.functions.map(func => {
                  if (func.functionName === "客源查看") {
                    this.permissionLevel = func.level;
                    result = true
                  }
                });
                if (!result) {
                  this.permissionLevel = '';
                }
              } else if (obj === "WANT_TO_RENT" && child.name === "求租") {
                let result = false
                child.functions.map(func => {
                  if (func.functionName === "客源查看") {
                    this.permissionLevel = func.level;
                    result = true
                  }
                });
                if (!result) {
                  this.permissionLevel = '';
                }
              }
            });
          }
        });

      // if (this.searchInfo.typeValue === 'UNLIMITED') {
      //   this.searchInfo.typeValue = ''
      // }
      // console.log(this.searchInfo.date,1)
      var params = {
        transactionType: this.searchInfo.transactionType,
        "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize,
        "page.pageSize": this.pageSize,
        storeId: this.searchInfo.storeId,
        payWay: this.searchInfo.typeValue,
        source: this.searchInfo.sourceValue,
        employeeId: this.searchInfo.employeeId,
        customerLevel: this.searchInfo.levelValue,
        //entrustDate: this.searchInfo.date,
        date: this.searchInfo.date,
        string: this.searchInfo.key,
        clientId: this.searchInfo.clientId,
        // permissionLevel: this.permissionLevel,
        status: this.searchInfo.status,
        robCustomer: this.searchInfo.robCustomer,
        dateUpDown:this.dateUpDown,
        followDateUpDown:this.followDateUpDown
      };
      this.$post(findCustomer, params).then(res => {
        if (res.success === true) {
          this.customerData1 = res.data;
          this.customerData = res.data;
          this.total = res.total;
          this.customerData.map(item => {
            if (item.jobTractTime) {
              item.jobTractTime = item.jobTractTime.replace("T", "    ");
            }
          });
        } else {
          this.customerData1 = res.data;
          this.customerData = res.data;
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
      // this.$post(findCustomer, params).then(res => {
      //   if (res.success === true) {
      //     this.customerData1 = res.data;
      //   }
      // });
      //  //cosole.log(this.$store.state.customerType);
    },
    //选中客源
    handleSelectionChange(selection, row) {
      this.CustomerDataList = [];
      selection.map((item, index) => {
        this.CustomerDataList.push(item.customerId);
      });
    },

    //门店
    GetStroe() {
      var params = {
        "page.pageNumber": 0,
        "page.pageSize": 10000
      };
      this.$post(storeFind, params).then(res => {
        if (res.success === true) {
          this.storeData = res.data;
          // var no = {
          //   name: "不限",
          //   storeId: 0
          // };
          // this.storeData.unshift(no);
        }
      });
    },
    //付款方式
    GetPayway(value) {
      if (value === true) {
        var storeWay = "";
        if (this.customerType === "WANT_TO_BUY") {
          storeWay = BuyPayWay;
        } else if (this.customerType === "WANT_TO_RENT") {
          storeWay = RentPayWay;
        }
        this.$post(storeWay).then(res => {
          if (res.success === true) {
            this.typeData = res.data;
          }
        });
      }
    },
    //查询客源类型
    getCustomerType() {
      let params = {
        code: "customerType"
      };
      this.$post(dicGet, params).then(res => {
        if (res.success) {
          this.customerTypeList = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      })
    },
    //来源渠道
    getsource(value) {
      if (value === true) {
        var source = "";
        if (this.$store.state.customerType === "WANT_TO_BUY") {
          source = "buysource";
        } else if (this.$store.state.customerType === "WANT_TO_RENT") {
          source = "rentsource";
        }
        // if (this.$store.state.customerType !== this.$store.state.customerType){
        //     this.searchInfo.sourceValue = ''
        // }
        var params = {
          code: source
        };
        this.$post(dicGet, params).then(res => {
          if (res.success === true) {
            this.source = res.data;
            // var no = {
            //   valueDesc: "不限",
            //   value: ""
            // };
            // this.source.unshift(no);
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }
    },
    //客户等级
    getcustomerLevel(value) {
      if (value === true) {
        this.$post(customerLevel).then(res => {
          if (res.success === true) {
            this.customerLevel = res.data;
            // var no = {
            //   valueDesc: "不限",
            //   value: ""
            // };
            // this.customerLevel.unshift(no);
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }
    },
    //员工
    // Getmessage(value) {
    //   if (value === true) {
    //     var params = {
    //       "page.pageNumber": 0,
    //       "page.pageSize": 100000
    //     };
    //     this.$post(employeeQuery, params).then(res => {
    //       if (res.success === true) {
    //         this.employeesData = res.data;
    //         // var no = {
    //         //   name: "不限",
    //         //   id: ""
    //         // };
    //         // this.employeesData.unshift(no);
    //       }
    //     });
    //   }
    // },
    querySearchAsync(queryString, cb) {
      let params = {
        name: queryString,
        status:'ENABLE',
        departmentId:this.searchInfo.storeId
      };

      this.$post(employeeQuery, params).then(res => {
        if (res.success) {
          if (res.data.length<=0){
            this.$message.error('该部门下没有人员！');
          }
          this.employeesData = res.data;
          let restaurants = this.employeesData;
          cb(restaurants);
          if (!this.searchInfo.employeeName) {
            this.searchInfo.employeeId = '';
            this.handleCurrentChange(1);
          }

        } else {
        }
      });
    },
    handleSelect(item) {
      console.log(123, item)
      this.searchInfo.employeeId = item.id;
      this.searchInfo.employeeName = item.name;
      this.handleCurrentChange(1);
      //cosole.log(this.contractMsg.signer)
    },
    //添加客源
    addHouse() {
      //  //cosole.log(this.$store.state.customerType)
      this.$router.push({ path: "/customerAdd" });
    },
    //统计
    Tostatistics() {
      this.$router.push({ path: "/statistics" });
    },
    //客源详情
    tableRowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    gocustomerDetails(row) {
      var index = row.index;
      this.$router.push({ path: "/purchaseDetail" });
      localStorage.setItem("customerId", this.customerData[index].customerId);
      sessionStorage.setItem("employeeId", this.customerData[index].employeeId);
    },
    //导出
    toDao() {
      if (this.customerData1.length !== 0) {
        this.dialogVisible = true;
      }
    },
    daochu(event) {
      if (this.checkList.length === 0) {
        event.cancelBubble = true;
        event.stopPropagation();
        this.$message({
          type: "error",
          message: "请选择要导出信息"
        });
      } else {
        this.list = {};
        let changList = [];
        this.checkList.map((item, index) => {
          item = item.split(":");
          //  //cosole.log(item);
          changList.push(item);
        });
        changList.map((item, index) => {
          this.list[item[0]] = item[1];
        });
        //  //cosole.log(this.list)
        this.dialogVisible = false;
        this.checkList = [];
      }
    }
  },
  mounted() {
    // this.findCustomer(this.$store.state.customerType);
    this.findCustomer(this.$store.state.customerType);
    this.GetStroe();
    this.getdepartmentFindAll()
    // this.GetPayway();
    this.getstatus(true);
  },
  computed: {
    changeMemberTab() {
      if (this.$store.state.customerType === "") {
        this.$store.state.customerType = "WANT_TO_BUY";
      }
      this.pageNumber = 1;
      this.searchInfo.sourceValue = null;
      this.searchInfo.typeValue = null;
      // this.searchInfo.status = 'EFFECTIVE';
      this.ChangText();
      localStorage.setItem("ketype", this.$store.state.customerType);
      if (this.$store.state.customerType === "WANT_TO_BUY") {
        this.excelName = "客源求购列表";
      } else {
        this.excelName = "客源求租列表";
      }
      return this.$store.state.customerType;
    }
  },
  watch: {
    changeMemberTab(val) {
      this.pageNumber = 1;
      this.currentPage = 1;
      this.findCustomer(val);
      this.permisList = JSON.parse(sessionStorage.getItem('permisList'));
    }
  },
  activated() {
    this.findCustomer(this.$store.state.customerType);
    this.getdepartmentFindAll()
  }
};
</script>
<style lang="less">
.customer_list {
  .rowColor {
    color: #fff !important;
  }
  .el-select {
    min-width: 60px;
  }
  .el-table .cell.el-tooltip {
    width: 260px !important;
    margin-left: 10px;
  }
  .bianhao {
    .el-input {
      width: 165px;
      .el-input__inner {
        width: 165px;
      }
    }
  }
  .el-date-editor .el-range-input {
    background: #ffffff;
  }
  .el-range-editor.el-input__inner {
    padding: 0;
    /*border: none!important;*/
    width: 260px;
  }
}
.collect {
  width: 40px;
  height: 40px;
  cursor: pointer;
  i {
    color: #707070;
    &.active {
      color: red;
    }
  }
}
.task_list_list .el-input__prefix {
  display: none;
}
.customer_list .el-checkbox__inner::after {
  height: 3px;
  left: 2px;
}
/*.el-table--enable-row-hover .el-table__body tr:hover > td {*/
/*  background-color: #f5f5f5 !important;*/
/*}*/
/*.el-checkbox__input{*/
/*line-height: 9px;*/
/*}*/
.customer_list .el-input__inner {
  background: #ffffff !important;
  border: 1px solid #dbdbdb !important;
  border-radius: 4px !important;
}

/*.sales_list_wrap  .el-table--border td{*/
/*  !*border-bottom: 1px solid #999999;*!*/
/*  !*color: #000000;*!*/
/*  }*/
.sales_list_wrap .el-table::before {
  height: 0;
}
/* .el-table td, .el-table th.is-leaf{*/
/*  border-bottom: 1px solid #999999;*/
/*  border-right: 1px solid #999999;*/
/*  color: #000000;*/
/*}*/
.sales_list_wrap .el-table--border th.is-leaf {
  padding: 5px;
  color: #000000;
}
</style>
<style type="text/css" lang="less" >
.customer_el_menu {
  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    text-align: center;
  }

  // .el-popper .popper__arrow,
  // .el-popper .popper__arrow::after {
  //   border: none;
  // }

  // .el-popper[x-placement^=bottom] {
  //   margin-top: 0;
  // }
  .el-dropdown-menu__item {
    float: left;
    width: 33.33%;
    display: flex;
    flex-direction: column;
    line-height: 15px;
    padding: 0;
    align-items: center;
    margin-top: 28px;
    color: #5e75e6;
    font-size: 14px;
    padding-top: 10px;
    text-align: center;
  }
  .add_font {
    font-size: 30px;
  }

  .add_sales {
    margin-top: 8px;
  }
  #add_title {
    font-size: 14px;
    line-height: 14px;
    color: #999999;
    padding: 0 10px;
    margin-top: 5px;
  }
}

.customer_list {
  height: 100%;
  min-width: 1200px;
  position: relative;
  background: #ffffff;

  .sales_header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .chouse_wrap {
      display: flex;
      height: 60px;
      align-items: center;
      flex-wrap: wrap;
      max-width: 1550px;
      min-width: 1290px !important;

      .task_list_list {
        display: flex;
        margin-right: 40px;

        .task_list_item {
          display: flex;
          width: auto;
          background: white;
          margin-left: 10px !important;
          position: relative;
          .txt {
            font-size: 12px;
            padding: 0 !important;
            /*display: flex;*/
            /*justify-content: center;*/
            /*align-items: center;*/
            background: #ffffff !important;
            color: #666666 !important;
          }
          .inp_box {
            display: flex;
            align-items: center;
            width: 100px;

            > input {
              width: 50px;
              text-align: center;
              font-size: 14px;
              height: 100%;
              outline: none;
            }
          }

          // .icon-icon_S-niandai,
          // .icon-icon_S-mendian,
          // .icon-icon_S-leixing-1,
          // .icon-icon_S-laiyuan,
          // .icon-icon_S-yuangong,
          // .icon-icon_S-zhuangtai {
          //   width: 30px;
          //   height: 30px;
          //   font-size: 20px;
          //   background: #ccc;
          //   border: none;
          // }

          .el-input__inner {
            height: 30px;
            border-radius: 0;
            border: 1px solid #ccc;
            padding-left: 10px;
            padding-right: 10px;
          }

          .el-input__prefix {
            background: #ccc;
            width: 30px;
            left: 0;
          }

          .el-input__icon {
            line-height: 30px;
            color: #c0c4cc !important;
          }

          &.mendian,
          &.zhuangtai {
            .icon-icon_S-niandai,
            .icon-icon_S-mendian,
            .icon-icon_S-leixing-1,
            .icon-icon_S-laiyuan,
            .icon-icon_S-yuangong,
            .icon-icon_S-zhuangtai {
              line-height: 30px;
              text-align: center;
              color: white;
            }

            .el-input__inner {
              padding-left: 10px;
            }
          }

          .icon-icon_xiangxia {
            position: absolute;
            right: 5px;
            top: 8px;
            color: #ccc;
          }
        }

        .el-input {
          height: 30px;

          .el-input-group__append,
          .el-input-group__prepend {
            padding: 0 10px;
            background: #5e75e6;
            /*border: none;*/
          }

          .el-input__inner {
            /*border: none;*/
            height: 30px;
            padding-right: 10px;
          }

          .icon-icon_sousuo {
            color: white;
          }
        }
      }
    }

    .sales_header_rigth {
      /*margin-bottom: 20px;*/
      /*margin-right: 20px;*/
      /*display: flex;*/
      /*justify-content: flex-end;*/
      margin-top: 15px;
      margin-left: 10px;

      .el-button--primary {
        width: 120px !important;
        height: 30px;
        line-height: 0;
      }

      .icon-xiajiantou {
        margin-right: 5px;
      }

      .el-button--primary {
        background: #5e75e6;
        border: none;
      }

      .el-dropdown-menu {
        width: 200px;
        // height: 280px;
      }
    }
  }

  /*.sales_list_wrap {*/
  /*.el-checkbox__inner {*/
  /*width: 10px;*/
  /*height: 10px;*/
  /*margin-bottom: 50px;*/
  /*margin-top: 10px;*/
  /*}*/
  /*}*/

  .footer_page {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;

    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #5e75e6;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border: 1px solid #ccc;
      background: white;
    }

    // .el-icon-arrow-left:before {
    //   content: "上一页";
    //   padding: 0 20px;
    //   color: #cccccc;
    //   font-size: 12px;
    // }

    // .el-icon-arrow-right:before {
    //   content: "下一页";
    //   padding: 0 20px;
    //   color: #cccccc;
    //   font-size: 12px;
    // }
  }
}
.el-checkbox-group {
  margin: 0 20px 20px 20px;
}
.foot-out-left .tongji,
.foot-out-left .daochu,
.foot-out-left .shoucang {
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  margin-right: 10px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
}
.tongji {
  width: 100px;
  background: #5e75e6;
}
.daochu {
  width: 80px;
  background: rgb(34, 202, 133) !important;
}
.shoucang {
  width: 110px;
  background: rgb(255, 144, 77) !important;
}
.checkbox-out {
  overflow: hidden;
  margin-left: 25px;
  margin-bottom: 30px;
  margin-top: 10px;
}
.checkbox {
  float: left;
  margin-right: 25px;
  margin-bottom: 6px;
}
input[type="checkbox"] {
  width: 10px;
  height: 10px;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  border-radius: 2px;
  outline: none;
  vertical-align: middle;
  margin-top: 1px;
  margin-right: 5px;
}
input[type="checkbox"]:checked {
  /*background: url("../images/checkbox_icon.png")no-repeat center;*/
  background: #5e75e6;
}
input[type="checkbox"]:checked::before {
  display: block;
  content: "\2713";
  text-align: center;
  font-size: 6px;
  color: white;
  position: relative;
  top: -5px;
}
.el-dialog__footer {
  background: #f5f5f5;
  padding-top: 20px;
}
.cusp {
  cursor: pointer;
}
.foot-out {
  display: flex;
  justify-content: space-between;
}
.foot-out-left {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  margin-left: 20px;
}
.customer_list .iconfont {
  font-size: 24px;
  vertical-align: middle;
}
</style>
